import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ClassSettingsIndex from './routes/ClassSettingsIndex';
import AttendanceSettings from './routes/AttendanceSettings';

const ClassSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ClassSettings' */ './components/ClassSettings'
		)
);

export default (store) => {
	return {
		path: 'settings',
		element: <AsyncLoading component={<ClassSettingsLazy />} />,
		children: [ClassSettingsIndex(store), AttendanceSettings(store)],
	};
};
